import { CatalogElementPage } from "./CatalogElementPage";
import { Route, Routes } from "react-router-dom";

type Props = {};
const CatalogElement = (props: Props) => {
  return (
    <Routes>
      <Route index element={<CatalogElementPage />}></Route>
      <Route path=":elementId" element={<CatalogElementPage />}></Route>
    </Routes>
  );
};
export default CatalogElement;
